<template>
  <b-card-actions action-collapse title="Agents list">
    <b-row> 
      <b-col md="12">

         <b-modal
          id="modal-prevent-closing"
          ref="my-modal"
          title="Add agent"
          ok-title="Submit"
          cancel-variant="outline-secondary"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
          size="lg"
        >
          <form
            ref="form"
            @submit.stop.prevent="handleSubmit"
          >

          

              <b-form-group
            :state="nameState"
              label="Company"
              label-for="company"
            >
              <b-form-input
                id="company"
                placeholder="Company"
                v-model="form.company"
                :state="nameState"
              />
            </b-form-group>
             <b-row> 
      <b-col md="6">
           <b-form-group
            :state="nameState"
              label="Person in charge: FirstName"
              label-for="FirstName"
            >
              <b-form-input
                id="FirstName"
                placeholder="Firstname"
                v-model="form.firstName"
                :state="nameState"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
            :state="nameState"
              label="Person in charge:  LastName"
              label-for="LastName"
            >
              <b-form-input
                id="LastName"
                placeholder="Lastname"
                v-model="form.lastName"
                :state="nameState"
              />
            </b-form-group>
            </b-col>
             </b-row>
            <b-form-group
            :state="nameState"
              label="VAT N°"
              label-for="VAT"
            >
              <b-form-input
                id="VAT"
                placeholder="VAT N°"
                v-model="form.vatNumber"
                :state="nameState"
              />
            </b-form-group>
            
            <b-form-group
              :state="nameState"
              label="Tax registration number"
              label-for="socialReason"
            >
              <b-form-input
                :state="nameState"
                id="socialReason"
                v-model="form.taxRegistrationNumber"
                placeholder="Tax registration number"
              />
            </b-form-group>

            <b-form-group
              :state="nameState"
              label="Country"
              label-for="country"
            >
              <b-form-select
                v-model="form.country"
                :options="Paysoptions"
                id="country"
                text-field="name"
                value-field="name"
                @change="getState()"
              />
            </b-form-group>
        <b-form-group
              :state="nameState"
              label="City"
              label-for="City"
  
            >
              <b-form-select
                v-model="form.city"
                :options="Cityoptions"
                              text-field="name"
                value-field="name"
                id="City"
              />
            </b-form-group>

            <b-form-group
              :state="nameState"
              label="Address"
              label-for="address"
            >
              <b-form-input
                :state="nameState"
                id="address"
                v-model="form.address"
                placeholder="Address"
              />
            </b-form-group>

            <b-form-group
            :state="nameState"
              label="Phone"
              label-for="phoneNumber"
            >
                <b-form-select
                v-model="form.phonePrefix"
                :options="prefixPhone"
                text-field="dial_code"
                value-field="dial_code"
              />
              <b-form-input
                :state="nameState"
                id="phoneNumber"
                type="number"
                v-model="form.phoneNumber"
                placeholder="Phone"
              />
            </b-form-group>

            <!-- <b-form-group
            :state="nameState"
              label="Settings"
              label-for="settings"
            >
              <b-form-checkbox-group
                v-model="form.settings"
                :options="Settingoptions"
                value-field="item"
                text-field="name"
                id="settings"
              />
            </b-form-group> -->

            <!-- <b-form-group
            :state="nameState"
              label="Port of registry"
              label-for="port"
            >
              <b-form-select
                v-model="form.seaPort"
                :options="Portoptions"
                id="port"
              />
            </b-form-group> -->

            <b-form-group
              :state="nameState"
              label="Email"
              label-for="email"
            >
              <b-form-input
                :state="nameState"
                id="email"
                type="email"
                v-model="form.email"
                placeholder="Email"
              />
            </b-form-group>
              <b-form-group
              :state="nameState"
              label="Password"
              label-for="Password"
            >
              <b-form-input
                :state="nameState"
                id="Password"
                type="text"
                v-model="form.password"
                placeholder="Password"
              />
            </b-form-group>
          </form>  
        </b-modal>
      </b-col>
      <b-col>

    <div class="custom-search">
      <!-- advance search input -->
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <!-- <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllclients()"
            >
              <feather-icon icon="TrashIcon" />
            </b-button> -->

               <b-button
                variant="gradient-primary"
              class="btn-icon btn-delete-all"
          v-b-modal.modal-prevent-closing
          style="width: 100%;"
        >
          <feather-icon
            icon="PlusCircleIcon"
          />
           Add agent
        </b-button>

            <!-- <download-excel
              :data="json_data"
              name="clients.xls"
              :fields="json_fields"
              class="btn-delete-all"
            >
              <b-button
                variant="gradient-primary"
                class="btn-icon btn-delete-all"
              >
                <feather-icon icon="DownloadIcon" />
              </b-button>
            </download-excel> -->
          </div>
        </b-form-group>
      </div>
    </div>
    </b-col>
    </b-row> 
    <!-- table -->
    <!-- :rtl="direction" -->
    <vue-good-table
      ref="table-client"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      theme="my-theme"
    >
      <template slot="table-row" slot-scope="props" class="table-added-element">
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="selectQuote(props.row._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/sale/quotations?id=${props.row._id}`">Quotations</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="selectInstantQuote(props.row._id)">
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span><router-link :to="`/instant-estimation?id=${props.row._id}`">Instant Estimate</router-link></span>
              </b-dropdown-item>

              <b-dropdown-item @click="UpdateClient(props.row._id)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span><router-link :to="`/agents/edit?id=${props.row._id}`">Update informations</router-link></span>
              </b-dropdown-item>


              <b-dropdown-item @click="DeleteAgent(props.row.user._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete account</span>
              </b-dropdown-item>

            </b-dropdown>
          </span>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
        <!-- <span v-if="props.column.field === 'visitingDays'">
        <ul v-for="(day, index) in props.row.visitingDays" :key="index">
            <li>{{ day }}</li>
          </ul> 
          <div>{{ props.row.visitingDays }}</div>
        </span>-->
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card-actions>
</template>

<script>
import VueBarcode from "vue-barcode";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BRow,
  BCol,
  BImg,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BFormCheckbox,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
import vSelect from 'vue-select'
import countriesList from '../../country_city.json';
import countriesPrefix from '../../Country.json';

export default {
  directives: {
    Ripple,
  },
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    VueBarcode,
    BImg,
    BButton,
    BCardActions,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    vSelect,
    BFormCheckbox,
    BFormCheckboxGroup,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      json_data: [],
      // json_fields: {
      //   VAT: "VAT",
      //   "Social reason": "socialReason",
      //   Country: "country",
      //   City: "city",
      //   Address: "address",
      //   phone: "phoneNumber",
      //   "Settings": "settings",
      //   "Port of registry": "port",
      //   Email: "email",
      // },
      pageLength: 5,
      dir: false,
      columns: [
         {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "First Name",
          field: "firstName",
          filterOptions: {
            enabled: true,
            placeholder: "First Name",
          },
        },
        {
          label: "Last Name",
          field: "lastName",
          filterOptions: {
            enabled: true,
            placeholder: "Last Name",
          },
        },
        {
          label: "Email ",
          field: "user.email",
          filterOptions: {
            enabled: true,
            placeholder: "Email",
          },
        },
     
        {
          label: "Company",
          field: "company",
          filterOptions: {
            enabled: true,
            placeholder: "Company",
          },
        },
        {
          label: "Country",
          field: "country",
          filterOptions: {
            enabled: true,
            placeholder: "Country",
          },
        },
         {
          label: "City",
          field: "city",
          filterOptions: {
            enabled: true,
            placeholder: "City ",
          },
        },
          {
          label: "Address",
          field: "address",
          filterOptions: {
            enabled: true,
            placeholder: "Address ",
          },
        },
         {
          label: "Phone Number",
          field: "phoneNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Phone Number",
          },
        },
          {
          label: "Vat Number",
          field: "vatNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Vat Number",
          },
        },
        //   {
        //   label: "Sea Port",
        //   field: "seaPort",
        //   filterOptions: {
        //     enabled: true,
        //     placeholder: "sea Port",
        //   },
        // },
          {
          label: "Tax Registration Number",
          field: "taxRegistrationNumber",
          filterOptions: {
            enabled: true,
            placeholder: "Tax Registration Number",
          },
        },
        
        
      ],
      rows: [],
      searchTerm: "",
      form: {
        firstName: '',
        lastName: '',
        vatNumber: '',
        taxRegistrationNumber: '',
        email: '',
        phoneNumber: '',
        address: '',
        country: null,
        city: [],
        seaPort: null,
        settings: [],
         role:"agent",
         password:''
        },
      nameState: null,
      submittedData: {
        vatNumber: Number,
        taxRegistrationNumber: String,
        email: String,
        phoneNumber: String,
        address: String,
        country: String,
        city: String,
        seaPort: String,
        settings: Array,
        role:"agent"
      },
      Paysoptions: [
        { value: null, name: 'Please select an option' },
      ],
      Cityoptions: [
        { value: null, name: 'Please select an option' },
      ],
      prefixPhone:[
         { value: null, dial_code: 'Please select an option' },
      ]
      // Portoptions: [
      //   { value: null, text: 'Please select an option' },
      //   { value: 'Tunis', text: 'Tunis' },
      //   { value: 'France', text: 'France' },
      //   { value: 'Egypt', text: 'Egypt' },
      // ],
      // Settingoptions: [
      //   { item: 'A', name: 'Option A' },
      //   { item: 'B', name: 'Option B' },
      //   { item: 'D', name: 'Option C' },
      // ],
    };
  },
  async created() {
    await this.getAllDataAgent();
    this.Paysoptions=countriesList
    this.prefixPhone=countriesPrefix
  },
  methods: {
    getState(){
      const country = this.Paysoptions.find((c) => c.name === this.form.country);
      if (country) {
        console.log(country)
        this.Cityoptions = country.states
      } else {
        this.Cityoptions = [ { value: null, name: 'Please select an option' }];
      }
    },
    async getAllDataAgent() {
     
      const response = await axios.get(
        "https://mtl-feeder-nodejs.onrender.com/api/agents"
      );
      console.log(response);
      this.rows = response.data.data;
      // this.json_data = response.data.data;
    },
    //      deleteAllClients() {
    //   var deleteIds = [];
    //   this.$refs["table-client"].selectedRows.forEach((element) => {
    //     deleteIds.push(element._id);
    //   });
    //   console.log(deleteIds, this.$refs["table-client"].selectedRows);
    //   axios
    //     .delete(
    //       `https://mtl-feeder-nodejs.onrender.com/api/agents?ids=${deleteIds.join(
    //         ","
    //       )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
    //     )
    //     .then((response) => {
    //       this.getAllDataAgent();
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: `Client bien supprimé`,
    //           icon: "UserIcon",
    //           variant: "success",
    //         },
    //       });
    //     })
    //     .catch((error) => {
    //       this.$toast({
    //         component: ToastificationContent,
    //         props: {
    //           title: `Error`,
    //           icon: "UserIcon",
    //           variant: "danger",
    //         },
    //       });
    //       this.errorMessage = error.message;
    //       console.log(this.errorMessage);
    //     });
    // },
    DeleteAgent(id) {
      this.$swal({
        title: "you really want to delete this client ?",
        text: "You can't undo this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(
              "https://mtl-feeder-nodejs.onrender.com/api/users/"+id
            )
            .then((response) => {
              this.getAllDataAgent();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `agent deleted`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Error`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },

    UpdateClient(id) {
      var routerLink = "/agents/edit?id=" + id;
      this.$router.replace(routerLink);
    },
    selectQuote(id) {
       var routerLink = "/sale/quotations?id=" + id;
      this.$router.replace(routerLink);
    },
    selectInstantQuote(id) {
       var routerLink = "/instant-estimation?id=" + id;
      this.$router.replace(routerLink);
    },

    advanceSearch(val) {
      this.searchTerm = val;
    },
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    visitingDaysFormat: function (value) {
      if (value) {
        return value.join(", ");
      }
    },
    // name agent de saisie
    nameFormat: function (value) {
      return value.firstName + " " + value.lastName;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.firstName = '';
      this.nameState = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the link to submitted Data
      //this.submittedData.push(this.form.firstName);

      // this.submittedData.city=[]
      this.submittedData = this.form;
      // this.form.city.forEach(element => {
      //   this.submittedData.city.push(element.value)
      // });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      });

      axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/users",this.submittedData
        )
        .then((response) => {
          console.log(response);
          this.getAllDataAgent()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Agent added",
              icon: "EditIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error during add",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
      //  console.log("data firstname: " + this.submittedData.firstName);
      //   console.log("data lastname: " + this.submittedData.lastName);
      // console.log("data vatNumber: " + this.submittedData.vatNumber);
      // console.log("taxRegistrationNumber: " + this.submittedData.taxRegistrationNumber);
      // console.log("data email: " + this.submittedData.email);
      // console.log("data phoneNumber: " + this.submittedData.phoneNumber);
      // console.log("data settings: " + this.submittedData.settings);
      // console.log("data address: " + this.submittedData.address);
      // console.log("data port: " + this.submittedData.port);
      // console.log("data city: " + this.submittedData.city[0].title + " | "+ this.submittedData.city[1].title);
      // console.log("data country: " + this.submittedData.country);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}

.btn-delete-all {
  margin-left: 3%;
}
</style>
